<template>
  <aside role="navigation" :is="tag" :class="['fixed']" :style="{zIndex}" v-resize="onResize">
    <div
      :style="{zIndex}"
      :class="[baseCss, `${right ? 'right' : 'left' }-0`, collapsed ? 'bcq-navbar-collapsed' : null, internalBgColor, internalTextColor, 'duration-300', 'transition-all', `shadow-${elevation}`, 'p-2']">
      <slot />
    </div>
    <div v-if="temporary || floating" @click="$emit('collapse', !$event.value)" :class="['duration-300', 'transition-all', 'bcq-navbar-blocker', 'fixed', 'top-0', 'right-0', 'bottom-0', 'left-0']" :style="{zIndex: zIndex - 1}" />
    <reactive-style>
    .bcq-navbar
    {
      width: {{ width }}px;
    }

    .bcq-navbar.bcq-navbar-collapsed
    {
      {{ right ? 'right' : 'left' }}: -{{ width + offsetFix }}px;
    }
    </reactive-style>
  </aside>
</template>
<script>
import methods from '../../mixins/methods'
import computed from '../../mixins/computed'
import props from '../../mixins/props'
import Utils from '../../mixins/utils'

export default {
  name: 'Navbar',
  mixins: [
    props,
    methods,
    computed
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('navbar', ['overflow-auto', 'select-none', 'block', 'fixed', 'top-0', 'bottom-0']),
      offsetFix: 10
    }
  },
  model: {
    prop: 'collapsed',
    event: 'collapse'
  },
  props: {
    value: false,
    collapsed: null,
    floating: {
      type: Boolean
    },
    width: {
      type: Number,
      default: 300
    },
    right: {
      type: Boolean
    },
    tag: {
      type: String,
      default: 'aside'
    },
    temporary: {
      type: Boolean
    },
    bgColor: {
      type: String,
      default: 'white'
    },
    bgColorLightness: {
      type: [Number, String],
      default: null,
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    color: {
      type: String,
      default: 'black'
    },
    zIndex: {
      type: Number,
      default: 1000
    }
  },
  watch: {
    collapsed () {
      this.setAppBaseLayout()
      this.$emit('collapse', this.collapsed)
    },
    right () {
      this.setAppBaseLayout()
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    onMounted () {
      this.setAppBaseLayout()
    },
    onResize () {
      const viewport = this.viewport()
      this.$emit('resize', viewport)
    },
    setAppBaseLayout () {
      const appLevel = document.querySelectorAll('.bcq-app-level')
      const collapsed = this.collapsed
      const offset = this.width
      appLevel.forEach((element) => {
        element.style.marginLeft = null
        element.style.marginRight = null
        !this.floating ? element.style[this.right ? 'marginRight' : 'marginLeft'] = collapsed ? null : `${offset}px` : element.style[this.right ? 'marginRight' : 'marginLeft'] = null
      })
    }
  }
}
</script>
<style>
.bcq-navbar + .bcq-navbar-blocker
{
  background: var(--semi-transparent-light);
}

.bcq-ui-theme-dark .bcq-navbar + .bcq-navbar-blocker
{
  background: var(--semi-transparent-dark);
}

.bcq-navbar.bcq-navbar-collapsed + .bcq-navbar-blocker
{
  background: rgba(0, 0, 0, 0);
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/navbar/navbar.vue